import React, { useEffect, useState } from 'react'
import { Modal, Checkbox, CheckboxGroup, Button } from 'rsuite'
import './scss/cards.scss'
import axiosService from "../../utils/axios.service";
import { event } from 'jquery';
import { optionsTimeCard, optionsHourLast, optionsMinus, optionWaxing } from './constant/TimeUsingCard'
import Select from "react-select";
import CurrencyInput from 'react-currency-input-field';
import { notifications } from "../constant/Notify";
let _ = require('lodash');

const cardTypes = [
	{
		type: 1,
		text: "Thẻ số lần"
	},
	{
		type: 2,
		text: "Thẻ số tiền",
	}
]

const Edit = ({ open, setOpen, detailCard, editPackage, products, listSelectGroup}) => {
	const [cardType, setCardType] = useState(Number(detailCard.meta_object.card_type))
	const [productName, setProductName] = useState(detailCard.product_name)
	const [price, setPrice] = useState(detailCard.price)
	const [basePrice, setBasePrice] = useState(detailCard.base_price)
	const [categoryId, setCategoryId] = useState(detailCard.category_id)
	const [description, setDescription] = useState(detailCard.description)
	const [status, setStatus] = useState(detailCard.status)
	const [type, setType] = useState(detailCard.type)
	const [maxUsed, setMaxUsed] = useState(detailCard.meta_object.max_used)
	const [createCardType, setCreateCardType] = useState(detailCard.meta_object.card_type)
	const [typeUsing, setTypeUsing] = useState(detailCard.type_using == 1 ? true : false)
	const [comServe, setComServe] = useState(detailCard.com)
	const [specialService, setSpecialService] = useState(detailCard.special_service === 1 ? true : false)
	const [useTimeMonth, setUseTimeMonth] = useState(detailCard.meta_object.use_time_month)
	const [cardAccount, setCardAccount] = useState(detailCard.meta_object.card_account)
	const [productNameE, setProductNameE] = useState(detailCard.product_name_e)
	const [timeUsing, setTimeUsing] = useState(detailCard.meta_object.time_using)
	const [rangeDate, setRangeDate] = useState(detailCard.range_date)
	const [productId, setProductId] = useState("")
	const [upgradeId, setUpgradeId] = useState("")
	const [giftPackageId, setGiftPackageId] = useState("")
	const [defaultValueProduct, setDefaultValueProduct] = useState(null)
	const [defaultValueUpgrade, setDefaultValueUpgrade] = useState(null)
	const [defaultValueCategory, setDefaultValueCategory] = useState(null)
	const [defaultValueGiftPackage, setDefaultValueGiftPackage] = useState(null)
	const [lastHour, setLastHour] = useState(optionsHourLast[12].value)
	const [lastMinus, setLastMinus] = useState(optionsMinus[0].value)
	const [checkKey, setCheckKey] = useState(12)
	const [countVoucherUse, setCountVoucherUse] = useState(detailCard.count_voucher_use ?detailCard.count_voucher_use: 0)
	const [productUsingIds, setProductUsingIds] = useState("")
	const [defaultProductUsingId, setDefaultProductUsingId] = useState(null)
	const [typeSell, setTypeSell] = useState((detailCard.open_sell === 0) ? true : false)
	const [maxUseChild, setMaxUseChild] = useState((detailCard.max_use_child === 0) ? false : true)
	const [warranty, setWarranty] = useState(detailCard.meta_object?.warranty ?? 0)
	const [rangeWarranty, setRangeWarranty] = useState(detailCard.meta_object?.range_warranty ?? 0)
	const [newWaxing, setNewWaxing] = useState(() => {
		const filter = _.find(optionWaxing, function(o) { return o.value == detailCard.new_waxing })
		return filter
	})
	const [warrantyExpiry, setWarrantyExpiry] = useState(detailCard.meta_object.warranty_expiry)
	const [numberFamily, setNumberFamily] = useState(detailCard.number_family)

	let onChangeProductName = (event) => {
		setProductName(event.target.value)
	};

	let onChangeProductNameE = (event) => {
		setProductNameE(event.target.value)
	};

	let onChangePrice = (event) => {
		let dataPrice = event.target.value.replaceAll(",", "");
		setPrice(dataPrice)
	};

	let clickStatusCardType = (val) => {
		// setCardType(val)
		// setCreateCardType(val)
	};

	useEffect(() => {
		let checkKey = _.findIndex(optionsHourLast, function (o) { return o.value == detailCard.meta_object.last_hour });
		if (checkKey && typeof checkKey != 'undefined' && typeof optionsHourLast[checkKey] != 'undefined' && typeof optionsMinus[detailCard.meta_object.last_minute / 5] != 'undefined') {
			setLastHour(optionsHourLast[checkKey].value)
			setLastMinus(optionsMinus[detailCard.meta_object.last_minute / 5].value)
			setCheckKey(checkKey)
		}

		if (detailCard.category_id) {
			let checkKeyC = _.findIndex(listSelectGroup, function (o) { return o.value == detailCard.category_id });
			setDefaultValueCategory(listSelectGroup[checkKeyC])
		}

		// Buổi lẻ
		handleMetaList("product_id", setProductId, setDefaultValueProduct, true);

		// Thẻ nâng cấp
		handleMetaList("upgrade_id", setUpgradeId, setDefaultValueUpgrade);

		// Thẻ con
		handleMetaList("product_using_ids", setProductUsingIds, setDefaultProductUsingId);

		// Quà tặng
		handleMetaList("gift_package", setGiftPackageId, setDefaultValueGiftPackage);
	}, [detailCard, products])

	const handleMetaList = (metaKey, setIds, setDefaults, isSingle = false) => {
		const findIndex = detailCard.meta.findIndex(x => x.meta_key === metaKey);
		if (findIndex > -1) {
			let metaValue = detailCard.meta[findIndex].meta_value;

			// Nếu là single (chỉ 1 giá trị)
			if (isSingle) {
				setIds(metaValue);
				const product = products.find(x => x.value == metaValue) || null;
				setDefaults(product);
				return;
			}

			// Nếu là danh sách nhiều giá trị
			const arrayId = metaValue.split(",").map(Number);
			setIds(metaValue);	
			const optionList = products.filter(x => arrayId.includes(x.value));
			setDefaults(optionList);
		}
	};

	let onChangeTypeUsing = (event) => {
		setTypeUsing(!typeUsing)
	};

	let onChangeBasePrice = (event) => {
		let dataBasePrice = event.target.value.replaceAll(",", "");
		setBasePrice(dataBasePrice)
	};

	let onChangeDescription = (event) => {
		setDescription(event.target.value)
	};

	let onChangeCardAccount = (event) => {
		setCardAccount(event.target.value)
	}

	let onChangeUseTimeMonth = (event) => {
		setUseTimeMonth(event.target.value)
	}

	let onChangeComServe = (event) => {
		setComServe(event.target.value)
	}

	let onChangeTimeCard = (event) => {
		setTimeUsing(event.value)
	}

	let handleDefaultTimeCart = (timeUsing) => {
		let select = 0
		optionsTimeCard.map((val, key) => {
			if (val.value == timeUsing) {
				select = key
			}
		})
		return select
	}

	const addNewPackage = () => {
		let rawMeta = {
			"max_used": maxUsed,
			"card_type": createCardType,
			"use_time_month": useTimeMonth,
			"card_account": cardAccount,
			"time_using": timeUsing,
			"product_id": productId,
			"last_hour": lastHour,
			"last_minute": lastMinus,
			"upgrade_id": upgradeId,
			"gift_package": giftPackageId,
			"product_using_ids": productUsingIds,
			"warranty": warranty,
			"range_warranty": rangeWarranty,
			"warranty_expiry": warrantyExpiry
		}
		const meta_object = Object.keys(rawMeta).reduce((acc, key) => {
			const value = rawMeta[key];
			if (value !== undefined && value !== null && value !== "") {
				acc[key] = value;
			}
			return acc;
		}, {});

		const dataServices = {
			"product_name": productName,
			"price": price,
			"base_price": basePrice,
			"category_id": categoryId,
			"description": description,
			"status": status,
			"type": 2,
			"product_name_e": productNameE,
			"range_date": rangeDate,
			"count_voucher_use": countVoucherUse,
			"type_using": typeUsing ? 1 : 0,
			"open_sell": (typeSell) ? 0 : 1,
			"special_service": (specialService) ? 1 : 0,
			"max_use_child": (maxUseChild) ? 1 : 0,
			"com": comServe,
			"new_waxing": newWaxing?.value ?? 0,
			"number_family": numberFamily,
			"meta_object": meta_object
		}
		if (!productName || maxUsed == 0) {
			notifications({
				type: "error",
				mess: "Vui lòng điển đủ thông tin vào ô tô đậm",
			});
			return
		}
		editPackage(detailCard.id, dataServices)
		setOpen(false)
	}

	const onSelectProduct = (e) => {
		const value = e ? e.value : ""
		setProductId(value)
	}

	const onSelectGiftPackage = (e) => {
		let value = _.map(e, "value")
		setGiftPackageId(value)
	}

	const onSelectUpgrade = (e) => {
		let value = _.map(e, "value")
		setUpgradeId(value.join(','))
	}

	const onSelectProductUsingIds = (e) => {
		let value = _.map(e, "value")

		setProductUsingIds(value.join(','))
	}

	const onChangeLastHour = (event) => {
		setLastHour(event.value)
	}

	const onChangeLastMinus = (event) => {
		setLastMinus(event.value)
	}

	const onSelectCategory = (event) => {
		setCategoryId(event.value)
		if (event.value == 5) {
			setNewWaxing(optionWaxing[2])
		} else {
			setNewWaxing(optionWaxing[0])
		}
	}

	const onSelectNewWaxing = (event) => {
		setNewWaxing(event)
	}

	const onChangeUseVoucherCode = (event) => {
		setCountVoucherUse(event.target.value)
	}
	if (open) {
      return (
        <div className="popup-cent action-package">
          <div className="content-popup fadeInDown">
            <div className="head-popup">
              <div className="title">Sửa thẻ dịch vụ</div>
              <div className="close" onClick={() => setOpen(!open)}>×</div>
            </div>
            <div className="body-popup">
				<form>
					<div className="form-item-wrapper">
						<div className="flex justify-between">
							<label className="control-label left col-3">Tên thẻ</label>
							<div className="flex w-100"><input onChange={onChangeProductName} value={productName} className="form-control input-xs" placeholder="Tên thẻ" /></div>
						</div>
						{/* <div className="flex mt-10 justify-between">
							<label className="control-label left col-3">Tên tiếng anh</label>
							<input onChange={onChangeProductNameE} value={detailCard.product_name_e} className="form-control input-xs ng-pristine ng-untouched ng-valid ng-empty" placeholder="Nhập thẻ tên tiếng anh" />
						</div>
						<div className="flex mt-10 justify-between">
							<label className="control-label left col-3">Mô tả chức năng thẻ</label>
							<textarea onChange={onChangeDescription} value={detailCard.description} className="form-control input-xs ng-pristine ng-untouched ng-valid ng-empty" placeholder="Nhập thẻ tên tiếng anh" />
						</div> */}
						<div className="flex mt-10 justify-between">
							<label className="control-label left col-3">Giá bán thẻ</label>
							<div className="flex w-100">
								<CurrencyInput
									className="price-input required"
									placeholder="Nhập giá thẻ"
									value={price}
									groupSeparator={','}
									decimalSeparator={'.'}
									onChange={onChangePrice}
								/>
							</div>
						</div>
						{/* <div className="flex mt-10 justify-between">
							<label className="control-label left col-3">Loại thẻ</label>
							<div className="flex justify-between w-100">
								{cardTypes.map((item) => (
									<div onClick={() => clickStatusCardType(item.type)} className={`card-type ${cardType === item.type ? 'active' : ''}`} key={item.type}>{item.text}</div>
								))}
							</div>
						</div> */}
						{cardType == 1 ?
							<div className="flex mt-10">
								<label className="control-label left col-3">Thông tin sử dụng</label>
								<div className="row w-100">
									<div className="col-xs-12 col-md-6">
										<label className="control-label">Số buổi sử dụng</label>
										<input id="maxUsed" onChange={(e) => {setMaxUsed(e.target.value)}} className="form-control price-input w-100 required" value={maxUsed} />
									</div>
									<div className="col-xs-12 col-md-6">
										<label className="control-label">Số người sở hữu</label>
										<input type="number"  onChange={(e) => setNumberFamily(e.target.value)} className="form-control w-100 price-input" defaultValue={numberFamily} />
									</div>
								</div>
							</div>
						:
							<div className="flex mt-10 justify-between">
								<label className="control-label left col-3">Số tiền trong thẻ</label>
								<div className="flex w-100">
									<input onChange={onChangeCardAccount} value={detailCard.meta_object.card_account} className="ng-pristine ng-untouched ng-valid ng-empty" />
								</div>
							</div>
						}

						<div className="flex mt-10">
							<label className="control-label left col-3">Thời hạn thẻ</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<input value={detailCard.meta_object.use_time_month} onChange={onChangeUseTimeMonth} className="form-control w-20 price-input" placeholder="127" />
								<span className="input-group-addon">tháng từ ngày cấp</span>
							</div>
						</div>
						{cardType == 1 ?
							<div className="flex mt-10">
								<label className="control-label left col-3">Thời gian làm dịch vụ</label>
								<div className="row gap-20 item-flex-start w-100">
									<div className="col-6">
										{optionsTimeCard[0] ? 
											<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
												className="basic-single w-100"
												classNamePrefix="select"
												closeMenuOnSelect={true}
												isClearable={true}
												isSearchable={true}
												onChange={onChangeTimeCard}
												options={optionsTimeCard}
												defaultValue={optionsTimeCard[handleDefaultTimeCart(detailCard.meta_object.time_using)]}
											/> 
										: null}
									</div>
								</div>
							</div>
						: ""}
						<div className="flex mt-10">
							<label className="control-label left col-3">Thời gian đặt lịch muộn nhất</label>
							<div className=" gap-20 item-flex-start w-100">
								<div className="row">
									<div className="col-6">
										<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} className="select" onChange={onChangeLastHour} defaultValue={optionsHourLast[checkKey]} isSearchable={true} options={optionsHourLast} />
									</div>
									<div className="col-6">
										<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} className="select" onChange={onChangeLastMinus} defaultValue={optionsMinus[detailCard.meta_object.last_minute / 5]} isSearchable={true} options={optionsMinus} />
									</div>
								</div>
							</div>
						</div>
						<div className="flex mt-10">
							<label className="control-label left col-3">Thời gian dãn cách</label>
							<div className="flex gap-20 item-flex-start w-50 ">
								<input type="number" className="form-control w-20 price-input" min={1} value={rangeDate} onChange={(e) => {setRangeDate(e.target.value)}} />
							</div>
						</div>
						{/* <div className="flex mt-10">
							<label className="control-label left col-3">Tặng voucher gội đầu</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<input onChange={onChangeUseVoucherCode} className="form-control w-20 price-input" value={countVoucherUse} placeholder="Sô lần sử dụng" />
								<span className="input-group-addon">( Config số lần sử dụng )</span>
							</div>
						</div> */}

						<div className="flex mt-10">
							<label className="control-label left col-3">Buổi lẻ</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
									className="basic-single w-100"
									classNamePrefix="select"
									isClearable={true}
									defaultValue={defaultValueProduct}
									isSearchable={true}
									onChange={onSelectProduct}
									options={products}
								/>
							</div>
						</div>
						<div className="flex mt-10">
							<label className="control-label left col-3">Buổi tặng</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
									className="basic-single w-100"
									classNamePrefix="select"
									closeMenuOnSelect={false}
									isClearable={true}
									defaultValue={defaultValueGiftPackage}
									isSearchable={true}
									isMulti
									onChange={onSelectGiftPackage}
									options={products}
								/>
							</div>
						</div>
						<div className="flex mt-10">
							<label className="control-label left col-3">Nhóm dịch vụ</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
									className="basic-single w-100"
									classNamePrefix="select"
									isClearable={true}
									defaultValue={defaultValueCategory}
									isSearchable={true}
									onChange={onSelectCategory}
									options={listSelectGroup}
								/>
							</div>
						</div>

						{categoryId === 5 ? 
							<>
								<div className="flex mt-10">
									<label className="control-label left col-3">Thông tin bảo hành</label>
									<div className="row">
										<div className="col-xs-12 col-md-4">
											<label className="control-label">Số buổi</label>
											<input onChange={(e) => setWarranty(e.target.value)} className="form-control w-100 price-input" value={warranty} />
										</div>
										<div className="col-xs-12 col-md-4">
											<label className="control-label">Thời gian</label>
											<input onChange={(e) => setWarrantyExpiry(e.target.value)} className="form-control w-100 price-input" value={warrantyExpiry} />
											<span className="input-group-addon">(Đơn vị: Tháng)</span>
										</div>
										<div className="col-xs-12 col-md-4">
											<label className="control-label">Ngày dãn cách</label>
											<input onChange={(e) => setRangeWarranty(e.target.value)} className="form-control w-100 price-input" value={rangeWarranty} />
											<span className="input-group-addon">(Đơn vị: Ngày)</span>
										</div>
									</div>
								</div>

								<div className="flex mt-10">
									<label className="control-label left col-3">Loại thẻ triệt</label>
									<div className="flex gap-20 item-flex-start w-100">
										<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
											className="basic-single w-100"
											classNamePrefix="select"
											isClearable={true}
											isSearchable={true}
											defaultValue={newWaxing}
											onChange={onSelectNewWaxing}
											options={optionWaxing}
										/>
									</div>
								</div>
							</>								
						: null}

						<div className="flex mt-10">
							<label className="control-label left col-3">Nhóm dịch vụ nâng cấp</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
									className="basic-single w-100"
									classNamePrefix="select"
									closeMenuOnSelect={false}
									isClearable={true}
									defaultValue={defaultValueUpgrade}
									isSearchable={true}
									isMulti
									onChange={onSelectUpgrade}
									options={products}
								/>
							</div>
						</div>
						<div className="flex mt-10">
							<label className="control-label left col-3">Thẻ con</label>
							<div className="flex gap-20 item-flex-start w-100 ">
								<Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
									className="basic-single w-100"
									classNamePrefix="select"
									closeMenuOnSelect={false}
									isClearable={true}
									defaultValue={defaultProductUsingId}
									isSearchable={true}
									isMulti
									onChange={onSelectProductUsingIds}
									options={products}
								/>
							</div>
						</div>
						{productUsingIds.length > 0 ?
							<>
								<div className="flex mt-10">
									<label className="control-label left col-3">Kiểu sử dụng</label>
									<div className="flex align-center">
										<Checkbox checked={typeUsing} onChange={onChangeTypeUsing}>Sử dụng tính theo lần dịch vụ con</Checkbox>
									</div>
								</div>
								<div className="flex mt-10">
									<label className="control-label left col-3">Số lần sử dụng của thẻ con</label>
									<div className="flex align-center">
										<Checkbox checked={maxUseChild} onChange={() => setMaxUseChild(!maxUseChild)}>Số lần sử dụng của thẻ con tính theo thẻ cha</Checkbox>
									</div>
								</div>
							</>
						:null}
					</div>
					<div className="form-item-wrapper">
						<div className="flex mt-10">
							<label className="control-label left col-3">Com phục vụ</label>
							<div className=' gap-20 item-flex-start w-100'>
								<div className="row">
									<div className="col-6">
										<input value={comServe} onChange={onChangeComServe} className="form-control w-20 price-input" />
									</div>
									<div className="col-6">
										<Checkbox checked={specialService} onChange={() => setSpecialService(!specialService)}>Dịch vụ đặc biệt</Checkbox>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
            </div>
            <div className="bottom-popup">
              <div className="button-container">
				<div className="column-left">
					<Checkbox checked={typeSell} onChange={() => setTypeSell(!typeSell)}>Mở bán ?</Checkbox>
				</div>
				<div className="column-right">
					<div className="button-cent style3" onClick={() => setOpen(!open)}>
						<span><i className="fa-solid fa-x"></i></span>Đóng
					</div>
					<div className="button-cent" onClick={() => addNewPackage()}>
						<span><i className="fa-solid fa-file-lines"></i></span>Lưu thông tin
					</div>
				</div>
              </div>
            </div>
          </div>
          <div className="overlay" onClick={() => setOpen(!open)}></div>
        </div>
      );
    } else return <div></div>;
}

export default Edit